/* src/app/component/flightchangehistory/flightchangehistory.component.scss */
/*# sourceMappingURL=flightchangehistory.component-LWWODQUX.css.map */
